import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import useGetDetectByEvent from "../../hooks/useGetDetectByEvent";
import theme from "../../theme";
import DetectByDay from "./detectByDay";
import DetectByEvent from "./detectByEvent";
import DetectByHour from "./detectByHour";
import DetectByPeriod from "./detectByPeroid";
import SubHeader from "./subHeader";
import { differenceInDays, format, sub } from "date-fns";
import useGetDetectByDay from "../../hooks/useGetDetectByDay";
import useGetDetectByHour from "../../hooks/useGetDetectByHour";
import userStorage from "../../utils/userStorage";
import useGetDetectByMonth from "../../hooks/useGetDetectByMonth";
import Spinner from "../../components/spinner";
import { PageLayout } from "../../components/PageLayout";
import { useWindowSize } from "@reactuses/core";
import { MobilityListModal } from "./MobilityListModal";
import { useI18n } from "../../locales";

const { md } = theme.screen;

export interface FetchParams {
  // startDate: Date | null;
  // endDate: Date | null;
  mobFilter: number;
  groupId: string;
}

const Stastics: React.FC<{}> = () => {
  const { t } = useI18n();
  const user = userStorage.get();
  const { width } = useWindowSize();
  const [startDate, setStartDate] = useState<Date | null>(
    sub(new Date(), { days: 6 })
  );
  const [fakeStartDate, setFakeStartDate] = useState<Date | null>(
    sub(new Date(), { days: 6 })
  );
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [fakeEndDate, setFakeEndDate] = useState<Date | null>(new Date());
  const [fetch, setFetch] = useState(false);
  const [inValidDate, setInValidDate] = useState(false);
  const [diffDate, setDiffDate] = useState(0);
  const [groupSubCode, setGroupSubCode] = useState(""); // 하위그룹코드(api용)
  const [mobFilter, setMobFilter] = useState(-1);
  const [openList, setOpenList] = useState(false);
  const [eventCode, setEventCode] = useState(-1); // -1 전체

  // 조회버튼 클릭 (감지내역 통계)
  const onClickBtn = ({
    // startDate,
    // endDate,
    mobFilter,
    groupId,
  }: FetchParams) => {
    setFetch(true);
    setMobFilter(mobFilter);
    setGroupSubCode(groupId);
  };

  const resetFetch = () => {
    setFetch(false);
  };

  const { data: eventData, isLoading: eventDataIsLoading } =
    useGetDetectByEvent({
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      resetFetch,
      fetch,
      area: user?.area as string,
      mobility_code: mobFilter,
      ...(groupSubCode &&
        groupSubCode !== "all" && { groupId: groupSubCode }),
      // device_pid: null,
    });

  const { data: dayData, isLoading: dayDataIsLoading } = useGetDetectByDay(
    {
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      resetFetch,
      fetch,
      area: user?.area as string,
      mobility_code: mobFilter,
      ...(groupSubCode &&
        groupSubCode !== "all" && { groupId: groupSubCode }),
      // device_pid: null,
    }
  );

  const { data: monthData, isLoading: monthDataIsLoading } =
    useGetDetectByMonth({
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      resetFetch,
      fetch,
      area: user?.area as string,
      mobility_code: mobFilter,
      ...(groupSubCode &&
        groupSubCode !== "all" && { groupId: groupSubCode }),
    });

  useEffect(() => {
    if (startDate && endDate) {
      let diffDate = endDate.getTime() - startDate.getTime();
      setDiffDate(Math.floor(Math.abs(diffDate / (1000 * 60 * 60 * 24))));
    }
  }, [startDate, endDate]);

  const { data: hourData, isLoading: hourDataIsLoading } =
    useGetDetectByHour({
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      resetFetch,
      fetch,
      area: user?.area as string,
      mobility_code: mobFilter,
      ...(groupSubCode &&
        groupSubCode !== "all" && { groupId: groupSubCode }),
    });

  const changeStartDate = (date: Date | null) => {
    setFakeStartDate(date);
  };

  const changeEndDate = (date: Date | null) => {
    setFakeEndDate(date);
  };

  useEffect(() => {
    if (fetch) {
      if (differenceInDays(endDate as Date, startDate as Date) < 6) {
        setInValidDate(true);
      } else {
        setInValidDate(false);
      }
    }
  }, [endDate, startDate, fetch]);

  const getTotalDetect = () => {
    if (!eventData) return;
    let total = 0;
    eventData.forEach((el) => {
      if (el.event !== "전체농기계" && el.event !== "운행한농기계") total += el.cnt;
    });
    return total;
  };

  // 종류별 감지내역에서 이벤트 클릭
  const onClickEvent = (eventCode: number) => {
    setEventCode(eventCode);
    setOpenList(true);
  };

  // console.log(startDate, endDate);
  // console.log("eventData", eventData);
  // console.log("hourData", hourData);

  return (
    <PageLayout withoutBody={width > md ? true : false} withBreadcrumb>
      <SubHeader
        changeStartDate={changeStartDate}
        changeEndDate={changeEndDate}
        fakeEndDate={fakeEndDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        fakeStartDate={fakeStartDate}
        onClickBtn={onClickBtn}
        isMobileSize={width <= md ? true : false}
      />
      <Body>
        {/* 종류별 감지내역 */}
        {!inValidDate ? (
          <DetectByEvent
            onClickEvent={onClickEvent}
            eventData={eventData}
          />
        ) : (
          <DetectByEventError width={"252px"} height={"100%"}>
            {t.statistics.invalidPeriod}
          </DetectByEventError>
        )}

        {/* 일별 감지내역 */}
        <RightWrapper>
          {inValidDate ? (
            <DetectByEventError width={"1098px"} height={"531px"}>
              {t.statistics.invalidPeriod}
            </DetectByEventError>
          ) : dayDataIsLoading || monthDataIsLoading ? (
            <DetectByEventError width={"1098px"} height={"531px"}>
              <Spinner />
            </DetectByEventError>
          ) : !dayData || getTotalDetect() == 0 ? (
            <DetectByEventError width={"1098px"} height={"531px"}>
              {t.statistics.noData}
            </DetectByEventError>
          ) : (
            <DetectByDay
              dayData={dayData}
              monthData={monthData}
              diffDate={diffDate}
            />
          )}

          <RightInnerWrapper>
            {/* 기간 내 감지 내역 */}
            {inValidDate ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                {t.statistics.invalidPeriod}
              </DetectByEventError>
            ) : eventDataIsLoading ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                <Spinner />
              </DetectByEventError>
            ) : !eventData || getTotalDetect() == 0 ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                {t.statistics.noData}
              </DetectByEventError>
            ) : (
              <DetectByPeriod
                eventData={eventData}
                width={width <= md ? "100%" : undefined}
                height={width <= md ? "100%" : undefined}
              />
            )}
            {/* 시간대별 감지내역 */}
            {inValidDate ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                {t.statistics.invalidPeriod}
              </DetectByEventError>
            ) : hourDataIsLoading ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                <Spinner />
              </DetectByEventError>
            ) : !hourData || getTotalDetect() == 0 ? (
              <DetectByEventError width={"534px"} height={"382px"}>
                {t.statistics.noData}
              </DetectByEventError>
            ) : (
              <DetectByHour
                hourData={hourData}
                hourDataIsLoading={hourDataIsLoading}
                isMobile={width <= md ? true : false}
                width={width <= md ? "100%" : undefined}
                height={width <= md ? "100%" : undefined}
              />
            )}
          </RightInnerWrapper>
        </RightWrapper>
      </Body>
      {openList && (
        <MobilityListModal
          open={openList}
          onPressNo={() => setOpenList(false)}
          eventCode={eventCode}
          startDate={format(new Date(startDate as Date), "yyyy-MM-dd")}
          endDate={format(new Date(endDate as Date), "yyyy-MM-dd")}
          groupId={groupSubCode}
          mobility_code={mobFilter}
        />
      )}
    </PageLayout>
  );
};

const Body = styled.div`
  height: calc(100vh - 227px);
  min-height: 990px;
  display: flex;
  gap: 30px;
  padding-bottom: 17px;
  flex-shrink: 0;
  margin-bottom: 20px;

  @media (max-width: ${md}px) {
    height: auto;
    flex-direction: column;
    min-height: calc(100vh - 50px);
    min-width: calc(320px - 32px);
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (max-width: ${md}px) {
    gap: 8px;
  }
`;

const RightInnerWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 30px;

  @media (max-width: ${md}px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const DetectByEventError = styled.div<{
  width: string;
  height: string;
}>`
  width: ${({ width }) => width};
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  height: ${({ height }) => height};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: pre-line;
  line-height: 150%;
  align-items: center;
  font-weight: 600;
  text-align: center;

  @media (max-width: ${md}px) {
    width: 100%;
    height: 150px;
    border-radius: 5px;
    box-shadow: none;
    background-color: ${theme.color.white};
    font-size: ${theme.fontSize.FONT_1};
  }
`;

export default Stastics;
